import { render, staticRenderFns } from "./RadioVirtualAccountType.vue?vue&type=template&id=5d97473f&lang=pug"
import script from "./RadioVirtualAccountType.vue?vue&type=script&lang=js"
export * from "./RadioVirtualAccountType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports